import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/site";

export const WhatsAppButton = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with SLN Agro Exports on WhatsApp"
    data-testid="whatsapp-float-btn"
    className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-green-500 text-white pl-4 pr-5 py-3.5 shadow-lg shadow-green-900/20 hover:scale-105 hover:bg-green-600 transition-transform"
  >
    <MessageCircle className="h-5 w-5" />
    <span className="text-sm font-semibold hidden sm:inline">WhatsApp us</span>
  </a>
);
